import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { Menu, MenuItems } from "../../../shared/menu-items/menu-items";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ProfilingDetailsWarningComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/profiling-details-warning/profiling-details-warning.component";
import { Router } from "@angular/router";
import { ApplicationService } from "src/app/core/services/application.services";
import { JwtService } from "src/app/core/services/jwt.service";
import { MatSidenav } from "@angular/material/sidenav";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.scss"],
})
export class AppSidebarComponent implements OnDestroy, OnInit {

  @Input() sidenav: MatSidenav;
  
  mobileQuery: MediaQueryList;
  type;
  firstInitial: any;
  lastInitial: any;

  userApplications: any;

  private _mobileQueryListener: () => void;

  userData: any;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private dialog: MatDialog,
    private router: Router,
    private applicationService: ApplicationService,
    private jwt: JwtService
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("applicantDetails"))
      ? JSON.parse(localStorage.getItem("applicantDetails"))
      : JSON.parse(localStorage.getItem("evaluator_details"));

    this.firstInitial = this.userData?.firstName[0];
    this.lastInitial = this.userData?.lastName[0];

    if (this.userData.officeName) {
      this.type = "evaluator";
    } else {
      this.type = "applicant";
    }
  }

  getBackgroundStyle() {
    let url;
    if (this.type === "evaluator") {
      switch (this.userData.officeValue) {
        case 1:
          url = "../../../../assets/logos/bcpo.jpeg";
          break;
        case 2:
          url = "../../../../assets/logos/health.jpeg";
          break;
        case 3:
          url = "../../../../assets/logos/peso.jpeg";
          break;
        case 4:
          url = "../../../../assets/logos/baguio_city.jpeg";
          break;
        case 5:
          url = "../../../../assets/logos/baguio_city.jpeg";
          break;
        default:
          break;
      }

      return {
        "background-image": `url(${url})`,
        "background-size": "cover",
        "background-position": "center",
        "background-repeat": "no-repeat",
      };
    }
    return {}; // Return an empty object for other cases
  }

  getToolTip(menuItem) {
    if (menuItem.disabled) {
      return "Feature available soon.";
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

 
  logMenu(menuitem: Menu) {

    if (this.mobileQuery.matches) {
      this.sidenav.toggle();
    }


    this.userData = JSON.parse(localStorage.getItem("applicantDetails"))
      ? JSON.parse(localStorage.getItem("applicantDetails"))
      : JSON.parse(localStorage.getItem("evaluator_details"));

    if (this.userData) {
      const isProfileComplete = this.userData.isProfileComplete;

      switch (menuitem.name) {
        case "Dashboard":
          // Remove trackers for receipts
          localStorage.removeItem("policeClearanceSearched");
          localStorage.removeItem("ptrSearched");
          localStorage.removeItem("workingPermitSearched");
          localStorage.removeItem("cedulaReceiptSearched");

          if (this.type == "applicant") {
            if (isProfileComplete) {
              return true;
            } else {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              const dialogRef = this.dialog.open(
                ProfilingDetailsWarningComponent,
                dialogConfig
              );
              dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                  window.location.reload(); // reload the page
                }
              });
              return false;
            }
          }
          break;

        case "New Application":
          let pageReloaded = false;

          // Remove trackers for receipts
          localStorage.removeItem("policeClearanceSearched");
          localStorage.removeItem("ptrSearched");
          localStorage.removeItem("workingPermitSearched");
          localStorage.removeItem("cedulaReceiptSearched");

          if (isProfileComplete) {
            localStorage.removeItem("newApplicationDetails");
            localStorage.removeItem("draftApplication");
            return true;
          } else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            const dialogRef = this.dialog.open(
              ProfilingDetailsWarningComponent,
              dialogConfig
            );
            dialogRef.afterClosed().subscribe((result) => {
              if (result && !pageReloaded) {
                pageReloaded = true;
                window.location.reload();
              }
            });
            return false;
          }

        case "My Applications":
          // Remove trackers for receipts
          localStorage.removeItem("policeClearanceSearched");
          localStorage.removeItem("ptrSearched");
          localStorage.removeItem("workingPermitSearched");
          localStorage.removeItem("cedulaReceiptSearched");

          this.applicationService
            .getApplications(this.userData.id)
            .subscribe((result) => {
              this.userApplications = result;


              const userApplicationsJSON = JSON.stringify(
                this.userApplications
              );
            });

          if (isProfileComplete) {

            return true;
          } else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            const dialogRef = this.dialog.open(
              ProfilingDetailsWarningComponent,
              dialogConfig
            );
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                window.location.reload(); // reload the page
              }
            });
            return false;
          }

        case "Profile":

          // Remove trackers for receipts
          localStorage.removeItem("policeClearanceSearched");
          localStorage.removeItem("ptrSearched");
          localStorage.removeItem("workingPermitSearched");
          localStorage.removeItem("cedulaReceiptSearched");

          if (isProfileComplete) {
            return true;
          } else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            const dialogRef = this.dialog.open(
              ProfilingDetailsWarningComponent,
              dialogConfig
            );
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                window.location.reload(); // reload the page
              }
            });
            return false;
          }

        case "Log Out":
          localStorage.clear();
          if (this.type === "applicant") {
            this.router.navigate([""]);
          } else if (this.type === "evaluator") {
            this.router.navigate(["evaluator/sign-in"]);
          }
      }
    }
  }
}
